import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';

export const selectSettingsFeature = (state: AppState) => state.projectionState;
export const selectSettings = createSelector(selectSettingsFeature, (state) => state.settings);
export const selectSettingsLoading = createSelector(selectSettingsFeature, (state) => state.loadingSettings);
